import React, { useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Badge,
  Modal,
} from "reactstrap";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import axios from "../../../utills/api";
import PaymentBreakdownModal from "./PaymentBreakdownModal";
import InvoiceModal from "./components/InvoiceModal";
import EditReservationModal from "./EditReservationModal";
import { toast } from "react-toastify";

const ReservationDetails = ({
  selectedBooking,
  selectedKyc,
  onUploadKyc,
  refreshBookings,
}) => {
  if (!selectedBooking) {
    console.log("selectedKyc", selectedKyc);
    return (
      <Card>
        <CardBody className="text-center py-5">
          No Reservation Selected
        </CardBody>
      </Card>
    );
  }
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
const [cancelLoading, setCancelLoading] = useState(false);
const [cancellationReason, setCancellationReason] = useState("");

  const [previewImage, setPreviewImage] =
    useState(null);

  const [paymentModal, setPaymentModal] =
    useState(false);

  const [paymentData, setPaymentData] =
    useState(null);

  const [invoiceModal, setInvoiceModal] =
  useState(false);

  const getStatusColor = () => {
    const status =
      selectedBooking?.status?.toLowerCase();

    if (status === "cancelled")
      return "danger";

    if (status === "pending")
      return "warning";

    if (status === "checked in")
      return "success";

    if (status === "checked out")
      return "secondary";

    return "primary";
  };

  const handleCheckoutClick = async () => {

    try {

      // Step 1:
      // Calculate checkout settlement

      await axios.put(
        `/bookings/calculate-checkout/${selectedBooking.bookingId}`
      );


      // Step 2:
      // Fetch latest payment breakdown

      await fetchPaymentDetails();


    } catch (err) {

      console.error(
        "CHECKOUT SETTLEMENT ERROR",
        err
      );


      toast.error(
        err?.response?.data?.message ||
        "Unable to calculate checkout"
      );

    }

  };

  const fetchPaymentDetails =
    async () => {
      try {
        const res =
          await axios.get(
            `/checkout/checkout/${selectedBooking.bookingId}`
          );

        const apiData =
          res.data || {};

        if (
          !apiData ||
          !apiData.booking
        )
          return;

          setPaymentData(apiData.booking);
setPaymentModal(true);

        setPaymentModal(true);
      } catch (err) {
        console.error(err);
      }
    };

  const isFinalPaymentDone =
    selectedBooking?.payments?.some(
      (p) => p.paymentType === "final"
    );

const handleDownloadInvoice = () => {
  setInvoiceModal(true);
};

  const formatVariance = (
    mins,
    type,
    mode
  ) => {

    if (
      type === "ON_TIME" ||
      mins === 0
    ) {
      return `${mode} On Time`;
    }

    const abs =
      Math.abs(mins);

    const hrs =
      Math.floor(abs / 60);

    const min =
      abs % 60;

    const text =
      `${hrs > 0 ? hrs + " hr " : ""}${min} mins`;

    return type === "EARLY"
      ? `Early ${mode} by ${text}`
      : `Late ${mode} by ${text}`;
  };

  const handleCheckIn = async () => {
    try {

      const now = new Date();

      const scheduled =
        new Date(
          selectedBooking.scheduledCheckInDateTime
        );

      const diffMinutes = Math.round(
        (now - scheduled) /
        (1000 * 60)
      );

      const response = await axios.put(
        `/bookings/checkin/${selectedBooking.bookingId}`,
        {
          actualCheckIn: now,
        }
      );

      if (
        response.data
          .earlyCheckInCharge > 0
      ) {
        toast.warning(
          `Early Check-In Charge ₹${response.data.earlyCheckInCharge}`
        );
      }

      if (diffMinutes > 0) {
        toast.info(
          `Guest checked in ${diffMinutes} minutes late`
        );
      } else if (diffMinutes < 0) {
        toast.info(
          `Guest checked in ${Math.abs(
            diffMinutes
          )} minutes early`
        );
      } else {
        toast.success(
          "Guest checked in on time"
        );
      }

      await refreshBookings(selectedBooking.bookingId);

    } catch (err) {
      console.log(err);

      toast.error(
        "Unable to check-in guest"
      );
    }
  };

  const handleCheckOut = async () => {
    try {
      const now = new Date();

      const scheduled = new Date(
        selectedBooking.scheduledCheckOutDateTime
      );

      const diffMinutes = Math.round(
        (now - scheduled) /
        (1000 * 60)
      );

      const response =
        await axios.put(
          `/bookings/checkout/${selectedBooking.bookingId}`,
          {
            actualCheckOut: now,
          }
        );

      const data = response.data;

      // Late checkout charge
      if (
        data.lateCharge > 0 ||
        data.lateCheckOutCharge > 0
      ) {
        toast.warning(
          `Late Check-Out Charge ₹${data.lateCharge ||
          data.lateCheckOutCharge
          }`
        );
      }

      // Checkout timing message
      if (diffMinutes > 0) {
        toast.info(
          `Guest checked out ${diffMinutes} minutes late`
        );
      } else if (diffMinutes < 0) {
        toast.info(
          `Guest checked out ${Math.abs(
            diffMinutes
          )} minutes early`
        );
      } else {
        toast.success(
          "Guest checked out on time"
        );
      }

      await refreshBookings(selectedBooking.bookingId);

    } catch (err) {
      console.log(err);

      toast.error(
        err?.response?.data?.message ||
        "Unable to check-out guest"
      );
    }
  };

  const handleCancelBooking = async () => {
  if (!selectedBooking?.bookingId) {
    toast.error("Booking ID is missing.");
    return;
  }

  try {
    setCancelLoading(true);

    const response = await axios.put(
      `/bookings/${selectedBooking.bookingId}/cancel`,
      {
        reason:
          cancellationReason.trim() ||
          "Cancelled by property",
      }
    );

    if (response.data?.success) {
      toast.success(
        "Booking cancelled successfully."
      );

      setCancelModal(false);
      setCancellationReason("");

      await refreshBookings(
        selectedBooking.bookingId
      );
    } else {
      throw new Error(
        response.data?.message ||
          "Unable to cancel booking."
      );
    }
  } catch (err) {
    console.error(
      "CANCEL BOOKING ERROR:",
      err
    );

    toast.error(
      err?.response?.data?.message ||
        err?.message ||
        "Unable to cancel booking."
    );
  } finally {
    setCancelLoading(false);
  }
};

  return (
    <Card
      style={{
        borderRadius: "6px",
      }}
    >
      <CardBody className="p-3">
        <div className="text-center mb-4">
          <div
            className="mx-auto rounded-circle bg-primary text-white d-flex align-items-center justify-content-center fw-bold"
            style={{
              width: "65px",
              height: "65px",
              fontSize: "22px",
            }}
          >
            {selectedBooking?.name
              ?.split(" ")
              .map((x) => x[0])
              .join("")
              .substring(0, 2)
              .toUpperCase() || "--"}
          </div>
          <div className="mt-3">
           <ul className="list-inline mb-0 d-flex justify-content-center gap-2">

  {/* EDIT */}
  <li className="list-inline-item avatar-xs">
    <button
      className="btn btn-sm btn-soft-primary"
      onClick={() => setEditModal(true)}
    >
      <i className="ri-edit-line"></i>
    </button>
  </li>

  {/* CANCEL BOOKING */}
  {selectedBooking?.status !== "Cancelled" &&
   selectedBooking?.status !== "Checked Out" && (
    <li className="list-inline-item avatar-xs">
      <button
        type="button"
        className="btn btn-sm btn-soft-danger"
        title="Cancel Booking"
        onClick={() => setCancelModal(true)}
      >
        <i className="ri-close-circle-line"></i>
      </button>
    </li>
  )}

  {/* DELETE */}
  <li className="list-inline-item avatar-xs">
    <button
      className="btn btn-sm btn-soft-danger"
      onClick={() => setDeleteModal(true)}
    >
      <i className="las la-trash-alt"></i>
    </button>
  </li>

  {/* NOTIFICATION */}
  <li className="list-inline-item avatar-xs">
    <Button
      className="btn btn-sm btn-soft-warning"
      onClick={() => console.log("Notify")}
    >
      <i className="ri-notification-3-line"></i>
    </Button>
  </li>

</ul>
          </div>
          <Badge
            color={getStatusColor()}
            className="mt-2 px-3 py-2"
          >
            {selectedBooking.status}
          </Badge>

        </div>

        {/* BASIC INFORMATION */}

        <div className="border rounded p-3 mb-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="fw-bold mb-0">
              1. Basic Information
            </h6>
            {selectedKyc ? (
              <Button
                outline
                color="success"
                size="sm"
                disabled
              >
                ✅ Verified
              </Button>
            ) : (
              <Button
                color="dark"
                size="sm"
                onClick={() =>
                  onUploadKyc(
                    selectedBooking
                  )
                }
              >
                Upload KYC
              </Button>
            )}

          </div>

          <Row className="g-3">

            <Col xs={6}>
              <small className="text-muted">
                ID Type
              </small>

              <div className="fw-semibold">
                {selectedKyc?.idType ||
                  selectedBooking.idProofType ||
                  "-"}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                ID Number
              </small>

              <div className="fw-semibold">
                {selectedKyc?.idNumber ||
                  selectedBooking.idProofNumber ||
                  "-"}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                Address
              </small>

              <div className="fw-semibold">
                {selectedBooking.address ||
                  "-"}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                Nationality
              </small>

              <div className="fw-semibold">
                {!selectedKyc
                  ? "-"
                  : selectedKyc.idType === "passport"
                    ? selectedBooking?.nationality || "-"
                    : "Indian"}
              </div>
            </Col>

          </Row>

          {/* DOCUMENTS */}

          <Row className="mt-3">

            <Col xs={6}>
              {selectedKyc?.documents?.[0] ? (
                <img
                  src={`http://localhost:5000/${selectedKyc.documents[0].path}`}
                  alt="Front ID"
                  className="img-fluid border rounded"
                  style={{
                    height: "90px",
                    width: "100%",
                    objectFit: "cover",
                  }}

                />
              ) : (
                <div
                  className="border rounded d-flex justify-content-center align-items-center"
                  style={{
                    height: "90px",
                  }}
                >
                  ID Front
                </div>


              )}
            </Col>

            <Col xs={6}>
              {selectedKyc?.documents?.[1] ? (
                <img
                  src={`http://localhost:5000/${selectedKyc.documents[1].path}`}
                  alt="Back ID"
                  className="img-fluid border rounded"
                  style={{
                    height: "90px",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <div
                  className="border rounded d-flex justify-content-center align-items-center"
                  style={{
                    height: "90px",
                  }}
                >
                  ID Back
                </div>
              )}
            </Col>

          </Row>

        </div>

        {/* STAY DETAILS */}

        <div className="border rounded p-3 mb-3">

          <h6 className="fw-bold mb-3">
            2. Stay Details
          </h6>

          <Row className="g-3">

            <Col xs={6}>
              <small className="text-muted">
                Room Type
              </small>

              <div className="fw-semibold">
                {selectedBooking.roomType ||
                  "-"}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                Room Number
              </small>

              <div className="fw-semibold">
                {selectedBooking
                  ?.assignedRoom
                  ?.roomNumber || "-"}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                Scheduled Check-In
              </small>

              <div className="fw-semibold">
                {selectedBooking
                  ?.scheduledCheckInDateTime
                  ? new Date(
                    selectedBooking
                      .scheduledCheckInDateTime
                  ).toLocaleString()
                  : "-"}
              </div>
            </Col>
            <Col xs={6}>
              <small className="text-muted">
                Actual Check-In
              </small>

              <div className="fw-semibold">
                {selectedBooking
                  ?.actualCheckIn
                  ? new Date(
                    selectedBooking.actualCheckIn
                  ).toLocaleString()
                  : "-"}
              </div>
            </Col>
            {selectedBooking?.actualCheckIn && (
              <div className="mt-2">
                <span className="badge bg-info">
                  {formatVariance(
                    selectedBooking
                      ?.checkInVarianceMinutes,
                    selectedBooking
                      ?.checkInType,
                    "Check-In"
                  )}
                </span>
              </div>
            )}

            <Col md={6}>
              <small className="text-muted">
                Scheduled Check-Out
              </small>

              <div className="fw-semibold">
                {selectedBooking
                  ?.scheduledCheckOutDateTime
                  ? new Date(
                    selectedBooking.scheduledCheckOutDateTime
                  ).toLocaleString()
                  : "-"}
              </div>
            </Col>

            <Col md={6}>
              <small className="text-muted">
                Actual Check-Out
              </small>

              <div className="fw-semibold">
                {selectedBooking?.actualCheckOut
                  ? new Date(
                    selectedBooking.actualCheckOut
                  ).toLocaleString()
                  : "Not Checked-Out"}
              </div>
            </Col>
            <Col xs={4}>
              <small className="text-muted">
                Guests
              </small>

              <div className="fw-semibold">
                {
                  selectedBooking.numberOfGuests
                }
              </div>
            </Col>

            <Col xs={4}>
              <small className="text-muted">
                Adults
              </small>

              <div className="fw-semibold">
                {selectedBooking.adults}
              </div>
            </Col>

            <Col xs={4}>
              <small className="text-muted">
                Children
              </small>

              <div className="fw-semibold">
                {selectedBooking.children}
              </div>
            </Col>

          </Row>

        </div>

        {/* PAYMENT */}

        <div className="border rounded p-3 mb-4">

          <h6 className="fw-bold mb-3">
            3. Payment Information
          </h6>

          <Row className="g-3">

            <Col xs={6}>
              <small className="text-muted">
                Room Charge
              </small>

              <div className="fw-semibold">
                ₹
                {Number(
                  selectedBooking.roomCharge || 0
                ).toLocaleString()}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                No. of Nights
              </small>

              <div className="fw-semibold">
                {selectedBooking.nights}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                Total Paid
              </small>

              <div className="fw-semibold text-success">
                ₹
                {Number(
                  selectedBooking.totalPaid || 0
                ).toLocaleString()}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                Balance Amount
              </small>

              <div className="fw-semibold text-danger">
                ₹
                {Number(
                  selectedBooking.balanceAmount || 0
                ).toLocaleString()}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                Payment Status
              </small>

              <div
                className={`fw-semibold ${selectedBooking?.payments?.length
                  ? "text-success"
                  : ""
                  }`}
              >
                {selectedBooking?.payments?.length
                  ? "Paid"
                  : selectedBooking.statusPayment ||
                  "Unpaid"}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                Total Discount
              </small>

              <div className="fw-semibold text-warning">
                ₹
                {Number(
                  selectedBooking.discountAmount || 0
                ).toLocaleString()}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                Final Paid Amount
              </small>

              <div className="fw-semibold text-success">
                ₹
                {Number(
                  selectedBooking?.payments?.length
                    ? selectedBooking.payments[
                      selectedBooking.payments.length - 1
                    ]?.amount || 0
                    : 0
                ).toLocaleString()}
              </div>
            </Col>

            <Col xs={6}>
              <small className="text-muted">
                Payment Mode
              </small>

              <div className="fw-semibold">
                {selectedBooking?.payments?.length
                  ? (
                    selectedBooking.payments[
                      selectedBooking.payments.length - 1
                    ]?.method || "-"
                  )
                    .charAt(0)
                    .toUpperCase() +
                  (
                    selectedBooking.payments[
                      selectedBooking.payments.length - 1
                    ]?.method || ""
                  ).slice(1)
                  : "-"}
              </div>
            </Col>

          </Row>

        </div>

        {/* ACTION BUTTONS */}

        {selectedBooking?.payments?.some(
  (p) => p.paymentType === "final"
) ? (
  <Button
    color="primary"
    className="w-100"
    onClick={handleDownloadInvoice}
  >
    <i className="ri-file-text-line me-2"></i>
    Download Invoice
  </Button>
) : (
          <div className="d-flex gap-2">
            <Button
              color="success"
              className="flex-fill"
              onClick={handleCheckIn}
            >
              Check-In
            </Button>

            <Button
              color="danger"
              className="flex-fill"
              onClick={handleCheckoutClick}
            >
              Check-Out
            </Button>

            {/* <Button
  color="danger"
  onClick={handleCheckOut}
  disabled={
    !selectedBooking?.actualCheckIn ||
    selectedBooking?.actualCheckOut
  }
>
  Check-Out
</Button> */}
          </div>
        )}

      </CardBody>
      <Modal
  isOpen={cancelModal}
  toggle={() => {
    if (!cancelLoading) {
      setCancelModal(false);
      setCancellationReason("");
    }
  }}
  centered
>
  <div className="modal-header">
    <h5 className="modal-title">
      Cancel Booking
    </h5>

    <button
      type="button"
      className="btn-close"
      onClick={() => {
        if (!cancelLoading) {
          setCancelModal(false);
          setCancellationReason("");
        }
      }}
    />
  </div>

  <div className="modal-body">

    <div className="alert alert-warning">
      <i className="ri-alert-line me-2"></i>

      Are you sure you want to cancel this
      booking?

      <div className="mt-2">
        <strong>
          Booking:
        </strong>{" "}
        {selectedBooking?.bookingId}
      </div>

      <div>
        <strong>
          Guest:
        </strong>{" "}
        {selectedBooking?.name || "-"}
      </div>
    </div>

    <label className="form-label fw-semibold">
      Cancellation Reason
    </label>

    <textarea
      className="form-control"
      rows="3"
      placeholder="Enter cancellation reason..."
      value={cancellationReason}
      onChange={(e) =>
        setCancellationReason(
          e.target.value
        )
      }
      disabled={cancelLoading}
    />

  </div>

  <div className="modal-footer">

    <Button
      color="secondary"
      outline
      disabled={cancelLoading}
      onClick={() => {
        setCancelModal(false);
        setCancellationReason("");
      }}
    >
      Keep Booking
    </Button>

    <Button
      color="danger"
      disabled={cancelLoading}
      onClick={handleCancelBooking}
    >
      {cancelLoading ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
          />
          Cancelling...
        </>
      ) : (
        <>
          <i className="ri-close-circle-line me-1" />
          Cancel Booking
        </>
      )}
    </Button>

  </div>
</Modal>
      <PaymentBreakdownModal
        isOpen={paymentModal}
        toggle={() =>
          setPaymentModal(false)
        }
        paymentData={
          paymentData
        }
      />

      <InvoiceModal
  isOpen={invoiceModal}
  toggle={() =>
    setInvoiceModal(false)
  }
  bookingId={
    selectedBooking?.bookingId
  }
/>

      <EditReservationModal
        isOpen={editModal}
        toggle={() => setEditModal(false)}
        booking={selectedBooking}
        onUpdated={(updatedBooking) => {
          // ideally lift state up or refetch
          console.log("UPDATED BOOKING:", updatedBooking);
          window.location.reload();
        }}
      />
    </Card>

  );

};

export default ReservationDetails;